var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"header-title"},[_vm._v("Calculate your estimated DaaS costs")])}
var staticRenderFns = []

export { render, staticRenderFns }